import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const SaleForm = EgretLoadable({
  loader: () => import("./SaleForm")
});

const PreAuthForm = EgretLoadable({
  loader: () => import("./PreAuthForm")
});

const ReturnForm = EgretLoadable({
  loader: () => import("./ReturnForm")
});

const ForceForm = EgretLoadable({
  loader: () => import("./ForceForm")
});

const VoidList = EgretLoadable({
  loader: () => import("./VoidList")
});

const PreAuthList = EgretLoadable({
  loader: () => import("./PreAuthList")
});

const PaymentView = EgretLoadable({
  loader: () => import("./PaymentView")
});

const UnsettledList = EgretLoadable({
  loader: () => import("./UnsettledList")
});

const SettledList = EgretLoadable({
  loader: () => import("./SettledList")
});

const FailedList = EgretLoadable({
  loader: () => import("./FailedList")
});

const RecurringList = EgretLoadable({
  loader: () => import("../contacts/recurrings/RecurringList")
});

const paymentRoutes = [
  {
    path: "/payments/sale",
    component: SaleForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/sales/account/:accountId",
    component: SaleForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/sales/contact/:contactId/account/:accountId",
    component: SaleForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/preauth",
    component: PreAuthForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/return",
    component: ReturnForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/preauthcomplete",
    component: PreAuthList,
    auth: authRoles.merchant
  },
  {
    path: "/payments/force",
    component: ForceForm,
    auth: authRoles.merchant
  },
  {
    path: "/payments/void",
    component: VoidList,
    auth: authRoles.merchant
  },
  {
    path: "/payments/unsettled",
    component: UnsettledList,
    auth: authRoles.merchant
  },
  {
    path: "/payments/settled",
    component: SettledList,
    auth: authRoles.merchant
  },
  {
    path: "/payments/failed",
    component: FailedList,
    auth: authRoles.merchant
  },
  {
    path: "/payments/:id",
    component: PaymentView,
    auth: authRoles.merchant
  },
  {
    path: "/recurrings/recurring",
    component: RecurringList,
    auth: authRoles.merchant
  }
];

export default paymentRoutes;
